import { SUBSIDYTRANSACTIONCODES } from './constants';

export const checkTransactionCodes = (transactionCodes: Array<Object>) => {
  const trCodes = transactionCodes.map(
    (tr) => tr?.transactionCode?.code ?? null,
  );
  return SUBSIDYTRANSACTIONCODES.every((code) => trCodes.includes(code));
};
